module.exports = __webpack_public_path__ + "img/bug.d6d4eddc.svg";